// IT #414 (2026-10-26): every seal a Lala reply carries, first one first, none twice. ONE reader, so the drawer and the Ask Lala page
// cannot disagree about how many seals she handed over. Imports nothing but a type, so a .mjs gate RUNS it.
import type { DeliveredSeal } from "../components/SealCard";

export function sealsOf(seal?: DeliveredSeal | null): DeliveredSeal[] {
  if (!seal) return [];
  const all = [seal, ...(Array.isArray(seal.more) ? seal.more : [])];
  return all.filter((x, i) => Boolean(x && x.slug) && all.findIndex((y) => y && y.slug === x.slug) === i);
}
